import { Dialog } from '@material-ui/core';
import { useEffect, useMemo } from 'react';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import { useDriverPreferences } from 'shared/modules/driver/DriverPreferencesAPI';
import { trackDriverPreferences } from './DriverPreferencesAnalytics';
import { DriverPreferencesStepper } from './DriverPreferencesStepper';
import { BusinessTypeStep } from './steps/BusinessTypeStep';
import { TransportTypeStep } from './steps/TransportTypeStep';
import { VehicleDetailsStep } from './steps/VehicleDetailsStep';

const steps = [
  {
    label: 'Business Type',
    type: 'business_type',
    component: <BusinessTypeStep />,
  },
  {
    label: 'Transport Type',
    type: 'transport_details',
    component: <TransportTypeStep />,
  },
  {
    label: 'Vehicle Details',
    type: 'vehicle_details',
    component: <VehicleDetailsStep />,
  },
];

export function DriverPreferencesPage() {
  const { data } = useDriverPreferences();

  const activeStepIndex = useMemo(() => {
    const idx = steps.findIndex((step) => step.type === data?.onboarding_step);

    return idx === -1 ? 0 : idx;
  }, [data]);

  useEffect(() => {
    if (activeStepIndex === 0) {
      trackDriverPreferences({ name: 'Driver Started Preferences' });
    }
  }, [activeStepIndex]);

  useDocumentTitle('Driver Preferences');

  return (
    <Dialog fullWidth={true} open={true} fullScreen={true}>
      <DriverPreferencesStepper
        steps={steps}
        currentStepIndex={activeStepIndex}
      />
    </Dialog>
  );
}
